import { useAppSelector } from "../hooks";
import { getUserPermissions } from "../store/modules/AuthSlice";
import { RouterProvider } from "react-router";
import createAppRouter from "./index"; // see below

const AppRouter = () => {
    const userPermissions = useAppSelector(getUserPermissions);
    const router = createAppRouter(userPermissions);

    return <RouterProvider router={router} />;
};

export default AppRouter;
